import { useRef, useState } from "react";
import Buttons from "../../components/UI/Buttons";
import FieldLoader from "../../components/UI/FieldLoader";
import PERMISSIONS from "../../utils/AclPermissions";
import { isSet } from "../../utils/commonUtils";
import { createPortal } from "react-dom";
import Alert from "../../components/UI/ConfirmBox/Alert";
import FormInputs from "../../components/UI/FormInputs";

const ProgressNote = (props) => {
    const { updateProgress, visit_id, progressNote, setProgressNote } = props;
    const [loading, setLoading] = useState(false);
    const [disableBtn, setDisableBtn] = useState(true);
    const textareaRef = useRef(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const handleProgressData = async (isClear = false) => {
        // let rawValue = textareaRef?.current?.value;
        let rawValue = progressNote
        if (isClear) {
            rawValue = "";
            setDisableBtn(true)

        }
        setLoading(true);
        await updateProgress(visit_id, rawValue);
        setDisableBtn(true)
        setLoading(false);
        setShowDeleteModal(false);
    }
    const handleTextareaChange = (val) => {
        setProgressNote(val);
        setDisableBtn(false)
    }

    return (
        <>
            {showDeleteModal &&
                createPortal(
                    <Alert
                        onDelete={() => handleProgressData(true)}
                        onClose={() => setShowDeleteModal(false)}
                        content="Do you really want to Clear this record?"
                    />,
                    document.body
                )}
            {/* progress note */}
            {/* <div className="sh_cardFooter mx-3 sh_emrprogressfooter"> */}
                <div className="sh_emrtextareabox p-1 position-relative"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        minHeight: 0,
                        flex: 1
                    }}
                >
                    <FieldLoader isLoading={loading} />
                    <div className="d-flex card-header mb-2 align-items-center justify-content-between" style={{ flexShrink: 0 }}>
                        <h6 className="text-md font-weight-bold  mb-0">
                            Progress Note
                        </h6>
                        <div className="d-flex" style={{ gap: "5px" }}>
                            <Buttons
                                acl={
                                    !disableBtn
                                        ? PERMISSIONS.ANY_PERMISSION
                                        : PERMISSIONS.NO_PERMISSION
                                }
                                className="btn mb-1 sh_btnprimary btn-primary"
                                clickHandler={handleProgressData}
                                label={"Update"}
                            />
                            {/* <Buttons
                                acl={
                                    isSet(progressNote, false)
                                        ? PERMISSIONS.ANY_PERMISSION
                                        : PERMISSIONS.NO_PERMISSION
                                }
                                className="btn mb-1 sh_btnlight"
                                clickHandler={() => {
                                   setShowDeleteModal(true);
                                }}
                                label={"Clear All"}
                            /> */}
                        </div>
                    </div>
                    <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                         {/* <textarea
                        className="w-100 form-control form-control-solid"
                        name=""
                        id=""
                        rows="6"
                        value={progressNote}
                        ref={textareaRef}
                        onChange={(e) => {
                            handleTextareaChange(e?.target?.value);
                        }}
                    // onBlur={handleTextareaBlur}
                    /> */}
                        <FormInputs
                            type="Editor"
                            value={progressNote}
                            height="calc(100vh - 150px)"
                            formats={{
                                formats: [
                                    'background',
                                ],
                            }}
                            modules={{
                                toolbar: [
                                    ['bold'],
                                    [ { 'background': ['yellow','red','green','blue'] }],
                                     ['clean'],  
                                ],
                            }}
                            changeHandler={(value) => {
                                handleTextareaChange(value);
                            }}
                        />
                    </div>
                </div>
            {/* </div> */}
        </>
    );
}
export default ProgressNote;